import { HelpCenter } from "@mui/icons-material";
import { ThemeProvider, createTheme } from "@mui/material";
import MobileView from "components/wrapper_v2/MobileView";
import { COLOR_CONSTANTS } from "config/helpers/color_helper";
import { exceptionalRoutes } from "config/helpers/common_helper";
import { getPathNames } from "config/helpers/router_helper_v2";
import { isEqual } from "lodash";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

// const Wrapper = React.lazy(() => import("components/wrapper/Wrapper"));

export const AuthRoute = ({ component: Component }) => {
  const location = useLocation();
  const auth = useSelector((state) => state.auth, isEqual);
  const app = useSelector((state) => state.app, isEqual);
  const pathName = getPathNames()?.[1];
  const themeLight = useMemo(() => {
    document.documentElement.setAttribute("data-bs-theme", app.theme);
    return createTheme({
      palette: {
        mode: app.theme,
        ...(app.theme === "dark"
          ? {
            textFieldColor: "#387CA3",
            background: {
              default: "#2e3740",
              paper: "#2e3740",
            },
            primary: {
              main: COLOR_CONSTANTS.PRIMARY,
            },
            dataGridHeaderColor: "#00adb5",
          }
          : {
            textFieldColor: "#387CA3",
            primary: {
              main: COLOR_CONSTANTS.PRIMARY,
            },
            dataGridHeaderColor: "#f8f8f8",
          }),
      },
      zIndex: {},
      typography: {
        fontFamily: `"Poppins", sans-serif`,
      },
    });
  }, [app.theme]);

  const muiTheme = createTheme({
    typography: {
      // fontFamily: `"Poppins", sans-serif`,
      fontFamily: `"Poppins", sans-serif !important`,
    },
  });
  return !auth.isUserLoggedIn ? (
    <>
      <React.Suspense>
        <ThemeProvider theme={muiTheme}>
          <div
            className="noki-wrapper-message"
            style={{ display: exceptionalRoutes?.includes(pathName) && "none" }}
          >
            <MobileView />
          </div>
          <div className="noki-wrapper" style={{display:exceptionalRoutes?.includes(pathName) && 'block'}}>
            <Component />
          </div>
        </ThemeProvider>
      </React.Suspense>
    </>
  ) : (
    <Navigate
      to={{ pathname: "/home/dashboard" }}
      replace
      state={{ from: location }}
    />
  );
};

export const OpenRoute = ({ component: Component }) => {
  return (
    <>
      <React.Suspense>
        <Component />
      </React.Suspense>
    </>
  );
};

export const DashboardRoute = ({ component: Component }) => {
  const [Wrapper, setWrapper] = React.useState(null);

  useEffect(() => {
    const version = 2;
    if (version === 2) {
      const tempWrapper = React.lazy(() =>
        import("components/wrapper_v2/Wrapper")
      );
      setWrapper(tempWrapper);
    } else {
      const tempWrapper = React.lazy(() =>
        import("components/wrapper/Wrapper")
      );
      setWrapper(tempWrapper);
    }
  }, []);
  const inProgress = useSelector((state) => state.isLoading.progress);
  const encounterLoading=useSelector(state=>state?.isLoading?.encLoading)
  const auth = useSelector((state) => state.auth, isEqual);
  return auth.isUserLoggedIn ? (
    Wrapper ? (
      <div
        style={{
          cursor: (inProgress||encounterLoading) ? "progress" : "auto",
        }}
      >
        <div
          style={{
            pointerEvents: (inProgress||encounterLoading) ? "none" : "all",
          }}
        >
          <Wrapper>
            <>{Component}</>
          </Wrapper>
        </div>
      </div>
    ) : (
      <></>
    )
  ) : (
    <Navigate replace to={{ pathname: "/" }} />
  );
};
